import { gql } from '@efficiently/client-core-graphql-models';

export const GET_FINISHES = gql(`
	query ProjectLocationGetFinishes($projectId: String!) {
		finishes(projectId: $projectId) {
			...FinishDomainFinishFields
		}
	}
`);
